import {canScroll} from 'app/utils/smoothPageScroll';

export function getHashFromLink(link: HTMLAnchorElement) {
    if (!canScroll(link)) {
        return;
    }

    const url = link.href ? new URL(link.href) : undefined;
    if (!url) {
        return;
    }

    return link.hash.substring(1);
}
